var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AppState } from "@/share/AppState";
import { DateLib } from "@@/Datelib";
import { SearchDataType, SearchType } from "@@/ModuleJob";
import { ProjectObjectType } from "@@/Project";
import { CHATID } from "@@/Tags";
import { formatBytes } from "@@/Util";
import { action, observable, makeObservable } from "mobx";
import { FilterDialogState } from "../UIComponents/FilterDialogState";
import { TableRenderState } from "./TableRenderState";
export class LetrSearchStore {
    constructor() {
        this.activesearchtag = "files";
        this.activematchtype = SearchType.Phrase;
        this.searching = false;
        this.matchmessage = "";
        this.loadingmessage = "Searching";
        this.orderListItems = [];
        this.activetag = "";
        this.displayItems = [];
        this.activeletrid = "";
        this.searchid = "";
        this.searchterm = "";
        this.objectstermsmap = new Map();
        this.loadingmore = false;
        this.activeitemid = "";
        this.documentTableState = new TableRenderState();
        this.projectsobject = new Map();
        this.metaitems = new Map();
        this.showfilter = false;
        this.showcolview = false;
        this.hidecoilumn = new Set();
        this.cview = [];
        this.filterdialogstate = new FilterDialogState();
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetr((letr) => {
            this.activeletrid = letr;
            this.reset();
        });
        APPEvent.addSubscriberForAppState((st) => {
            if (st !== AppState.LoggedIn) {
                this.reset();
            }
        });
        APPEvent.addSubscriberForMsgByIds((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchid) {
                // we have now everything we need!!
                //we can do this as well but we okay fr now!
                res.msgs.forEach((msg) => {
                    const ditem = {
                        id: msg._id,
                        title: "By " + msg.user.name,
                        subheading: "On " + (DateLib.displayTime(msg.createdAt)),
                        body: msg.text,
                        actualobj: msg,
                        match: new Map()
                    };
                    this.addMatchDisplayItem(ditem);
                });
                this.setSearching(false);
                this.setLoadMore(false);
            }
        });
        APPEvent.addSubscriberForProjectObjectDetails((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchid) {
                const drows = [];
                res.objs.forEach((obj, index) => {
                    const mres = this.objectstermsmap.get(obj.id);
                    if (mres !== undefined) {
                        const mbypage = new Map();
                        mres.position.forEach((pos) => {
                            var _a;
                            if (!mbypage.has(pos.position.pagenumber)) {
                                mbypage.set(pos.position.pagenumber, new Set());
                            }
                            (_a = mbypage.get(pos.position.pagenumber)) === null || _a === void 0 ? void 0 : _a.add(pos.position.actualposition);
                        });
                        const ditem = {
                            id: mres.itemid,
                            title: obj.name,
                            subheading: this.activematchtype === SearchType.Phrase ? "" :
                                "Found terms: " + (Array.from(mres.terms).join(" ")),
                            body: "",
                            actualobj: obj,
                            match: mbypage
                        };
                        this.addMatchDisplayItem(ditem);
                        const robj = this.makeObjectForTable(obj, mbypage);
                        if (robj !== undefined) {
                            robj.rowindex = index;
                            drows.push(robj);
                        }
                    }
                });
                this.documentTableState.addRows(drows);
                this.setSearching(false);
                this.setLoadMore(false);
            }
        });
        APPEvent.addSubscriberForLetrSearch((res) => {
            if (this.searching && this.searchid === res.reqid && this.activeletrid === res.letrid) {
                if (res.matches !== undefined) {
                    const pids = new Set();
                    for (const re of res.matches.result) {
                        for (const d of re.indexdata) {
                            pids.add(d.itemid);
                        }
                    }
                    if (pids.size === 0) {
                        this.setSearching(false);
                        this.setMatchMessage("No match found");
                    }
                    else {
                        this.setMatchMessage("Found " + pids.size + " match" + (pids.size > 1 ? 'es' : ''));
                        this.setLoadingMessage("Loading Objects...");
                        this.arrangeResult(res.matches);
                    }
                }
                else {
                    this.setSearching(false);
                    this.setMatchMessage("No match found");
                }
            }
        });
        APPEvent.addSubcriberForGetMetadataa((res) => {
            if (res.isChooser) {
                return;
            }
            const meta = res.data;
            this.clearMetadata();
            for (const mt of meta) {
                if (mt.letrid === this.activeletrid) {
                    this.addMetadata(mt);
                }
            }
            this.addHeaders();
        });
    }
    hideCol(id) {
        this.hidecoilumn.add(id);
        this.addHeaders();
    }
    showCol(id) {
        this.hidecoilumn.delete(id);
        this.addHeaders();
    }
    setActiveItemid(id) {
        this.activeitemid = id;
        if (!id) {
            this.documentTableState.setSelectId("");
        }
    }
    addHeaders() {
        this.documentTableState.clearHeaders();
        const rows = this.documentTableState.getRows();
        this.documentTableState.clearRows();
        this.documentTableState.addHeaders([
            { label: 'Name', id: 'name', index: 0, width: (window.innerWidth * .75) / 2 },
            { label: 'Type', id: 'type', index: 1, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Size', id: 'size', index: 2, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Last Modified', id: 'lastmodified', index: 3, width: window.innerWidth * .75 / 2 / 3.2 }
        ].filter((sh) => !this.hidecoilumn.has(sh.id)));
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            this.documentTableState.addHeaders(mitems.filter((mitem) => !this.hidecoilumn.has(mitem.id)).map((mitem, index) => {
                const ret = {
                    label: mitem.name,
                    id: "custom_" + mitem.id,
                    index: index + 4,
                    width: 400
                };
                return ret;
            }));
        }
        this.addColumnViews();
        this.addProjectObjects(Array.from(this.projectsobject.values()));
    }
    addColumnViews() {
        var _a, _b, _c, _d;
        const lcopy = this.cview;
        this.cview.splice(0, this.cview.length);
        const lmap = new Map();
        lcopy.forEach((lc) => lmap.set(lc.id, lc.hidden));
        const sview = [{ label: 'Name', id: 'name', hidden: (_a = lmap.get("name")) !== null && _a !== void 0 ? _a : false },
            { label: 'Type', id: 'type', hidden: (_b = lmap.get("type")) !== null && _b !== void 0 ? _b : false },
            { label: 'Size', id: 'size', hidden: (_c = lmap.get("size")) !== null && _c !== void 0 ? _c : false },
            { label: 'Last Modified', id: 'lastmodified', hidden: (_d = lmap.get("lastmodified")) !== null && _d !== void 0 ? _d : false }];
        this.cview.push(...sview);
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            mitems.forEach((mi) => { var _a; return this.cview.push({ label: mi.name, id: mi.id, hidden: (_a = lmap.get(mi.id)) !== null && _a !== void 0 ? _a : false }); });
        }
    }
    addProjectObjects(objs) {
        const drows = [];
        objs.sort((o1, o2) => o1.updatetime - o2.updatetime);
        objs.forEach((ob, index) => {
            let add = true;
            // if (this.searchactive) {
            //     const index = this.searchmatches.indexOf(ob.id);
            //     if (index > -1) {
            //         add = true
            //     } else {
            //         add = false;
            //     }
            // }
            if (add) {
                const robj = this.makeObjectForTable(ob);
                if (robj !== undefined) {
                    robj.rowindex = index;
                    drows.push(robj);
                }
            }
        });
        this.documentTableState.addRows(drows);
    }
    getObject(id) {
        return this.projectsobject.get(id);
    }
    getSize(ob) {
        if (ob.type === ProjectObjectType.Document) {
            const dob = ob;
            return formatBytes(dob.size);
        }
        return "";
    }
    getModified(ob) {
        return DateLib.displayDate(ob.updatetime);
    }
    makeObjectForTable(ob, match) {
        this.projectsobject.set(ob.id, ob);
        // if (this.selecteditems.has(ob.id)) {
        //     this.actvefolderselectitem.add(ob.id);
        // }
        if (ob.type !== ProjectObjectType.Folder) {
            const dcol = [];
            if (!this.hidecoilumn.has("name")) {
                dcol.push({ id: ob.id + "_name", data: ob.name });
            }
            if (!this.hidecoilumn.has("type")) {
                dcol.push({
                    id: ob.id + "_type", data: ob.type, type: ob.type,
                    drafttype: ob.type === ProjectObjectType.Draft ? ob.drafttype : undefined
                });
            }
            if (!this.hidecoilumn.has("size")) {
                dcol.push({ id: ob.id + "_size", data: this.getSize(ob) });
            }
            if (!this.hidecoilumn.has("lastmodified")) {
                dcol.push({ id: ob.id + "_mod", data: this.getModified(ob) });
            }
            this.getMetadata().forEach((mt) => {
                if (!this.hidecoilumn.has(mt.id)) {
                    dcol.push({
                        id: "custom_" + mt.id,
                        data: "",
                    });
                }
            });
            const ret = {
                rowindex: 0,
                row: dcol,
                id: ob.id,
            };
            if (match !== undefined) {
                ret.match = match;
            }
            return ret;
        }
        return undefined;
    }
    clearMetadata() {
        this.metaitems.clear();
    }
    addMetadata(mt) {
        this.metaitems.set(mt.id, mt);
    }
    setShowColView(show) {
        this.showcolview = show;
    }
    setshowfilter(show) {
        this.showfilter = show;
    }
    getMetadata() {
        return Array.from(this.metaitems.values()).slice().sort((m1, m2) => m1.orderindex - m2.orderindex);
    }
    getProjectObject(id) {
        return this.projectsobject.get(id);
    }
    setActiveId(id) {
        this.activeitemid = id;
    }
    addMatchDisplayItem(item) {
        this.displayItems.push(item);
    }
    setLoadMore(loading) {
        this.loadingmore = loading;
    }
    arrangeResult(res) {
        var _a, _b;
        // lets do something clever now!
        // id -> terms!
        // then arrange the ids in order that's it!
        for (const term of res.result) {
            for (const idata of term.indexdata) {
                if (!this.objectstermsmap.has(idata.itemid)) {
                    this.objectstermsmap.set(idata.itemid, { itemid: idata.itemid, terms: new Set(), position: [] });
                }
                (_a = this.objectstermsmap.get(idata.itemid)) === null || _a === void 0 ? void 0 : _a.terms.add(term.term);
                (_b = this.objectstermsmap.get(idata.itemid)) === null || _b === void 0 ? void 0 : _b.position.push({ term: term.term, position: idata.position });
            }
        }
        this.orderListItems = [];
        const values = Array.from(this.objectstermsmap.values());
        values.sort((val1, val2) => val1.terms.size - val2.terms.size);
        // now we have the order list that' it
        this.orderListItems = values;
        const ids = this.orderListItems.splice(0, 100);
        // lets load now
        this.loadObjects(ids.map(id => id.itemid));
    }
    loadObjects(ids) {
        if (this.activesearchtag === 'files') {
            const req = {
                letrid: this.activeletrid,
                ids: ids,
                reqid: this.searchid
            };
            Apphandler.sendMessage("driveprojectids", req);
        }
        else if (this.activesearchtag === 'messages') {
            const res = {
                reqid: this.searchid,
                letrid: this.activeletrid,
                ids: ids
            };
            Apphandler.sendMessage("messagesbyids", res);
        }
    }
    loadmore() {
        if (this.loadingmore || this.orderListItems.length === 0) {
            return;
        }
        this.setLoadMore(true);
        const ids = this.orderListItems.splice(0, 100);
        this.loadObjects(ids.map(id => id.itemid));
    }
    clearTermsMap() {
        this.objectstermsmap.clear();
        this.orderListItems = [];
        this.displayItems = [];
        this.projectsobject.clear();
        this.documentTableState.clearTable();
    }
    setLoadingMessage(msg) {
        this.loadingmessage = msg;
    }
    setSearchterm(term) {
        this.searchterm = term;
    }
    setMatchMessage(msg) {
        this.matchmessage = msg;
    }
    setSearching(searching) {
        this.searching = searching;
    }
    setActiveSearchTag(tag) {
        console.log('setting ' + tag);
        this.activesearchtag = tag;
    }
    setActiveSearchType(tag) {
        this.activematchtype = tag;
    }
    reset() {
        this.setSearching(false);
        this.setSearchterm("");
        this.setActiveSearchTag(this.activetag === CHATID ? 'messages' : 'files');
        this.setActiveSearchType(SearchType.Phrase);
        this.clearTermsMap();
        this.setMatchMessage("");
        this.filterdialogstate.clear();
        this.documentTableState.clearHeaders();
        this.documentTableState.clearRows();
    }
    performSearch() {
        if (!this.searchterm.trim() && this.filterdialogstate.valuesbyid.size === 0) {
            return;
        }
        this.setshowfilter(false);
        // this.resetSelctedFolders();
        // this.searchstore.clear();
        this.setActiveItemid("");
        // this.setActiveFolderId("");
        const fil = [];
        if (this.filterdialogstate.valuesbyid.size > 0) {
            for (const [k, val] of this.filterdialogstate.valuesbyid) {
                fil.push(Object.assign(Object.assign({}, val), { id: k }));
            }
        }
        this.setSearching(true);
        this.setLoadingMessage("Searching...");
        this.setMatchMessage("");
        this.clearTermsMap();
        this.setActiveId("");
        this.addHeaders();
        const req = {
            reqid: this.searchid,
            letrid: this.activeletrid,
            searchterm: this.searchterm,
            operation: this.activematchtype,
            type: this.activesearchtag === 'files' ? SearchDataType.Drive : SearchDataType.Message,
            mfilter: fil
        };
        Apphandler.sendMessage("letrsearch", req);
    }
    performSearchOld() {
        if (!this.searchterm) {
            return;
        }
        this.setSearching(true);
        this.setLoadingMessage("Searching...");
        this.setMatchMessage("");
        this.clearTermsMap();
        this.setActiveId("");
        this.searchid = Math.random() + "";
        const req = {
            reqid: this.searchid,
            letrid: this.activeletrid,
            searchterm: this.searchterm,
            operation: this.activematchtype,
            type: this.activesearchtag === 'files' ? SearchDataType.Drive : SearchDataType.Message,
            mfilter: []
        };
        Apphandler.sendMessage("letrsearch", req);
    }
}
__decorate([
    observable,
    __metadata("design:type", String)
], LetrSearchStore.prototype, "activesearchtag", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], LetrSearchStore.prototype, "activematchtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "searching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "matchmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "loadingmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrSearchStore.prototype, "orderListItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrSearchStore.prototype, "displayItems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "searchterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrSearchStore.prototype, "objectstermsmap", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "loadingmore", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrSearchStore.prototype, "projectsobject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], LetrSearchStore.prototype, "metaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "showfilter", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], LetrSearchStore.prototype, "showcolview", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], LetrSearchStore.prototype, "hidecoilumn", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], LetrSearchStore.prototype, "cview", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "hideCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "showCol", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "addColumnViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "addProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "clearMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "addMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setShowColView", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setshowfilter", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setActiveId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "addMatchDisplayItem", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setLoadMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "arrangeResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "clearTermsMap", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setLoadingMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setSearchterm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setMatchMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setSearching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setActiveSearchTag", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "setActiveSearchType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LetrSearchStore.prototype, "performSearch", null);
